var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Not-Found"},[_vm._v("抱歉! 您没有权限查看该项目")])}
var staticRenderFns = []

export { render, staticRenderFns }